<template lang="pug">
.ChallengeResultPage
  .content
    .result
      .pane.leftPane
        .resultLast
          .title 今回の測定結果
          .flex
            km-rank-badge.badge(
              :score="challengeResult.last.score"
              :labelEnabled="true"
            )
            .stats
              .speed
                .label 入力速度
                .value
                  | {{challengeResult.last.score | toFixed(0)}}文字/10分
                  | ({{ (challengeResult.last.score / 600 ) | toFixed(1) }}文字/秒)

              .inputWords
                .label 入力文字数
                .value {{challengeResult.last.inputCount}}文字

              .inputTime
                .label 入力時間
                .value {{challengeResult.last.spendTime}}秒

              .backSpaceCount
                .label バックスペース<br>使用回数
                .value {{challengeResult.last.backspaceCount}}回
              .typeMissCount
                .label 入力ミス<br>回数
                .value {{challengeResult.last.wrongCount ? challengeResult.last.wrongCount : challengeResult.last.wrongLogs.length}}回
              .typeMissDetail
                .label 入力ミス<br>キー
                .value
                  span(v-for="key in challengeResult.last.wrongLogs") 「{{ key.targetCharacter }}」
              .time {{ challengeResult.last.date }} に記録更新
      .pane.rightPane
        .tabContainer
          .tab(:class="{current: tabIndex === 0 }")
            km-challenge-ranking(
              :title="this.embedded ? 'みんなの月間ランキング' : 'みんなのランキング'"
              :ranking="ranking"
            )
          .tab(:class="{current: tabIndex === 1 }")
            .resultBest
              .title 自己ベスト記録
              .newLabel(v-if="isNewRecord") 新記録!
              .flex
                km-rank-badge.badge(
                  :score="challengeResult.best.score"
                  :labelEnabled="true"
                )
                .stats
                  .speed
                    .label 入力速度
                    .value {{challengeResult.best.score | toFixed(0)}}文字/10分
                  .inputWords
                    .label 入力文字数
                    .value {{challengeResult.best.inputCount}}文字

                  .inputTime
                    .label 入力時間
                    .value {{challengeResult.best.spendTime}}秒

                  .backSpaceCount
                    .label バックスペース<br>使用回数
                    .value {{challengeResult.best.backspaceCount}}回
                  .typeMissCount
                    .label 入力ミス<br>回数
                    .value {{challengeResult.best.wrongCount ? challengeResult.best.wrongCount : challengeResult.best.wrongLogs.length}}回
                  .time {{ challengeResult.best.date }} に記録更新


        .tabMenu
          .tabMenuItem(
            v-menuHoverSound
            v-menuClickSound
            :class="{current: tabIndex === 0 }"
            @click="handleTabMenuClick('ranking')"
          ) ランキング
          .tabMenuItem(
            v-menuHoverSound
            v-menuClickSound
            :class="{current: tabIndex === 1 }"
            @click="handleTabMenuClick('mybest')"
          ) 自己ベスト記録
    .menu
      km-button.retryButton(
        size="large"
        styleName="primary"
        @click="handleRetryButtonClick"
      ) リトライ
      km-button.topButton(
        v-if="!embedded"
        size="large"
        styleName="common"
        @click="handleTopButtonClick"
      ) トップに戻る
      km-button.promotionButton(
        v-if="embedded"
        size="large"
        styleName="common"
        @click="handlePurchaseButtonClick"
      ) 製品版の購入はこちら

  km-footer(
    :navigationDisabled="embedded === true"
    title="測定結果"
  )
  km-message-overlay(
    v-if="isNewRecord || isRankIn"
    message="新記録です！"
    :duration=3000
  )
  km-name-input-overlay(
    v-if="embedded && tempName === '' && isRankIn"
    :wordCountPerMinute="challengeResult.last.score | toFixed(0) + '文字/10分('"
    :wordCountPerSecond="challengeResult.last.score / 600 | toFixed(0)+'文字/秒)'"
    @onSubmit="handleNameInputSubmit"
  )
  transition(name="fade")
    km-inline-frame-modal(
      v-show="promotionModalEnabled"
      src="/app/static/html/promotion.html"
      @onClose="handleInlineFrameModalClose"
    )

</template>

<script>
import { mapState } from 'vuex'
import firebase from 'firebase'
import RankBadge from '@/components/shared/RankBadge'
import ChallengeRanking from '@/components/shared/ChallengeRanking'
import MessageOverlay from '@/components/shared/MessageOverlay'
import NameInputOverlay from '@/components/shared/NameInputOverlay'
import InlineFrameModal from '@/components/shared/InlineFrameModal'

export default {
  name: 'challenge-result-page',
  components: {
    'km-rank-badge': RankBadge,
    'km-message-overlay': MessageOverlay,
    'km-name-input-overlay': NameInputOverlay,
    'km-challenge-ranking': ChallengeRanking,
    'km-inline-frame-modal': InlineFrameModal
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isNewRecord: false,
      isRankIn: false,
      promotionModalEnabled: false,
      tempName: '',
      ranking: [],
      tabIndex: 0
    }
  },
  computed: {
    ...mapState('User', {
      challengeResult: state => state.challenge_result
    })
  },
  methods: {
    checkRecord() {
      this.isNewRecord =
        this.challengeResult.best.date === this.challengeResult.last.date
      if (this.embedded) {
        if (this.ranking.length < 100) {
          this.isRankIn = true
          return
        }
        const lowestScore = this.ranking[this.ranking.length - 1]
        if (this.challengeResult.last.score > lowestScore) {
          this.isRankIn = true
        }
      }
    },
    async getRanking() {
      this.ranking = []
      await firebase
        .firestore()
        .collection('scores')
        .where('status', '==', true)
        .limit(100)
        .orderBy('score', 'desc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(docs => {
            this.ranking.push({
              name: docs.data().name,
              score: docs.data().score,
              backSpaceCount: docs.data().backspaceCount,
              date: docs.data().date
            })
          })
        })
    },
    addRecord() {
      if (this.embedded) {
        firebase
          .firestore()
          .collection('scores')
          .doc()
          .set(
            {
              score: Number(this.challengeResult.last.score.toFixed(1)),
              date: this.challengeResult.last.date,
              name: this.tempName,
              backspaceCount: Number(this.challengeResult.last.backspaceCount),
              status: true
            },
            { merge: true }
          )
      } else {
        const user = firebase.auth().currentUser
        firebase
          .firestore()
          .collection('scores')
          .doc(user.uid)
          .set(
            {
              score: Number(this.challengeResult.best.score.toFixed(1)),
              date: this.challengeResult.best.date,
              backspaceCount: Number(this.challengeResult.best.backspaceCount),
              status: true
            },
            { merge: true }
          )
      }
    },
    handleRetryButtonClick() {
      this.$router.push(
        (this.embedded ? '/embedded' : '') + '/challenge/player'
      )
    },
    handleTopButtonClick() {
      this.$router.push((this.embedded ? '/embedded' : '') + '/challenge/')
    },
    async handleNameInputSubmit(name) {
      this.tempName = name[0] + name[1] + name[2]
      await this.addRecord()
      await this.getRanking()
    },
    handleTabMenuClick(type) {
      switch (type) {
        case 'ranking':
          this.tabIndex = 0
          break
        case 'mybest':
          this.tabIndex = 1
          break
      }
    },
    handleInlineFrameModalClose() {
      this.promotionModalEnabled = false
    },
    handlePurchaseButtonClick() {
      window.open('https://kd.koredake.net/entry.php', '_new')
      // const targetElement = window.parent.document.getElementById('productInfo')
      // targetElement.scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  },
  filters: {
    toFixed: function(value, length) {
      return value.toFixed(length)
    }
  },
  async mounted() {
    if (this.embedded) {
      setTimeout(() => {
        this.promotionModalEnabled = true
      }, 2000)
    }
    await this.getRanking()
    this.checkRecord()
    if (!this.embedded && this.isNewRecord === true) {
      await this.addRecord()
    }
  }
}
</script>

<style lang="scss" scoped>
.ChallengeResultPage {
  height: 100%;
  width: 100%;
  background: url(../assets/bg_challenge.jpg) no-repeat;
}

.content {
  height: calc(100% - 80px);
  text-align: center;
}

.pane {
  position: relative;
  margin: 20px;
  padding: 20px;
  height: 500px;
  border: 5px solid #eee;
  background: rgba(255, 255, 255, 0.8);
  overflow: scroll;

  &.leftPane {
    width: calc(50% - 40px);
  }
  &.rightPane {
    width: calc(50% - 40px);
  }
}

.result {
  display: flex;
}

.resultLast,
.resultBest {
  .title {
    margin: 0 0 30px 0;
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
  }

  .flex {
    display: flex;
  }

  .badge {
    margin: 0 20px;
    width: 100px;
    height: 100px;
  }

  .stats {
    margin: 0 10px;
    width: calc(100% - 20px - 140px);

    .speed,
    .inputWords,
    .inputTime,
    .backSpaceCount,
    .typeMissCount,
    .typeMissDetail {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      margin: 5px;
      padding: 10px;
      width: calc(100% - 10px);
      height: 50px;
      border: 2px solid #333;
      background: #fff;
      vertical-align: top;
      border-radius: 5px;

      .label {
        width: 80px;
        text-align: left;
        font-size: 1.4rem;
        line-height: 1.2;
      }

      .value {
        width: calc(100% - 80px);
        text-align: right;
        font-size: 2rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .inputWords,
    .inputTime,
    .backSpaceCount,
    .typeMissCount {
      width: calc(50% - 10px);
    }

    .backSpaceCount,
    .typeMissCount {
      margin-bottom: 20px;
    }

    .backSpaceCount {
      .label {
        width: 150px;
      }
    }

    .typeMissDetail {
      margin-bottom: 20px;
    }

    .time {
      margin: 0 5px 0;
      text-align: right;
    }
  }
}

.resultBest {
  //   position: relative;
  //   text-align: center;

  //   .title {
  //     margin: 0 0 20px 0;
  //     font-size: 2rem;
  //     font-weight: bold;
  //   }

  .newLabel {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 5px 20px;
    background: red;
    color: #fff;
    border-radius: 50px;
  }

  //   .flex {
  //     display: flex;
  //   }

  //   .badge {
  //     margin: 0 20px 20px;
  //     width: 100px;
  //     height: 100px;
  //   }

  //   .stats {
  //     margin: 0 10px;
  //     width: calc(100% - 20px - 140px);

  //     .speed,
  //     .inputWords,
  //     .inputTime,
  //     .backSpaceCount,
  //     .typeMissCount {
  //       display: inline-flex;
  //       align-items: center;
  //       margin: 5px;
  //       padding: 10px;
  //       width: calc(100% - 10px);
  //       height: 50px;
  //       border: 2px solid #333;
  //       background: #fff;
  //       vertical-align: top;
  //       border-radius: 5px;

  //       .label {
  //         width: 45%;
  //         text-align: left;
  //         font-size: 1.4rem;
  //         line-height: 1.2;
  //       }

  //       .value {
  //         width: 55%;
  //         text-align: right;
  //         font-size: 2rem;
  //       }
  //     }

  //     .inputWords,
  //     .inputTime,
  //     .backSpaceCount,
  //     .typeMissCount {
  //       width: calc(50% - 10px);
  //     }

  //     .backSpaceCount,
  //     .typeMissCount {
  //       margin-bottom: 20px;
  //     }

  //     .time {
  //       text-align: right;
  //     }
  //   }
}

.menu {
  margin: 20px;
  text-align: center;
}

.tabContainer {
  display: flex;
  flex-direction: column;

  .tab {
    display: none;

    &.current {
      display: block;
    }
  }
}

.tabMenu {
  position: absolute;
  bottom: 0;
  display: flex;
  margin: 0 -20px 0;
  width: 100%;

  &Item {
    flex-grow: 1;
    padding: 15px 0;
    border-bottom: 0;
    background: #eee;
    color: #999;
    &.current {
      background: transparent;
      border-top: 0;
      color: #333;
    }
  }
}

.retryButton,
.topButton,
.promotionButton {
  display: inline-block;
  // margin: 0 10px 0 0;
  // padding: 20px 40px;
  width: 300px;
  // background: #eee;
  // font-size: 3rem;
  // border-radius: 5px;
}

.retryButton {
  width: 300px;
  // background: orange;
  // color: #fff;
  // text-align: center;
}

.promotionButton {
  width: 400px;
}
</style>
